<template>
  <input
    type="number"
    class="bg-input"
    v-bind:value="value"
    v-on:input="$emit('input', parseInt($event.target.value || '0'))"
  />
</template>

<script>
export default {
  name: "NumberInput",
  props: ["value"]
};
</script>

<style scoped></style>
